import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export function getIntroSteps(isMobile: boolean): DriveStep[] {
    return [
        {
            popover: {
                title: "Welcome to the Vålerenga Performance Hub! 🏒",
                description:
                    "This platform is your central command for tracking, analyzing, and elevating our on-ice performance. " +
                    "We use a custom-built KPI system to translate complex game data into clear, actionable scores — giving you instant insights " +
                    "into active rosters, match outcomes, and historic achievements. " +
                    "<br/><br/>" +
                    "Over the next few steps, we'll take a quick tour of how to navigate the app, then we'll proceed with diving into each tab individually.",
                align: "center",
            },
        },
        {
            element: `#${isMobile ? ONBOARDING_IDS.GUIDE_ICON_MOBILE : ONBOARDING_IDS.GUIDE_ICON}`,
            popover: {
                description:
                    "If you stop the onboarding process, you can press this info icon at any time. " +
                    "It will guide you step-by-step through the features of whichever tab you currently have open.",
                side: isMobile ? "left" : "bottom",
                align: isMobile ? "center" : "end",
            },
        },
    ];
}

/** @deprecated use getIntroSteps(isMobile) */
export const introSteps: DriveStep[] = getIntroSteps(false);
